import * as React from "react";

interface UsePopoverReturn<T extends HTMLElement = HTMLElement> {
	anchorRef: React.MutableRefObject<T | null>;
	handleClose: () => void;
	handleOpen: () => void;
	handleToggle: () => void;
	open: boolean;
}

export function usePopover<
	T extends HTMLElement = HTMLElement,
>(): UsePopoverReturn<T> {
	const anchorRef = React.useRef<T>(null);
	const [open, setOpen] = React.useState(false);

	const handleOpen = React.useCallback(() => {
		setOpen(true);
	}, []);

	const handleClose = React.useCallback(() => {
		setOpen(false);
	}, []);

	const handleToggle = React.useCallback(() => {
		setOpen((prevState) => !prevState);
	}, []);

	return { anchorRef, handleClose, handleOpen, handleToggle, open };
}
